<template lang="pug">
.ncons.epw-ncons.active
  .accepted-payments.mb-2
    small {{$t('ui.payment_list')}}:
    .apm
      img(src='/images/depo/bank/rhb.png')
      img(src='/images/depo/bank/bsn.png')
      img(src='/images/depo/bank/cimb.png')
      img(src='/images/depo/bank/mbb.png')
      img(src='/images/depo/bank/pbb.png')
  .mb-3
    label.col-form-label {{ $t('ui.amount') }} ({{ $t("ui.min") }} {{ $t("ui.amount") }}:  {{ this.$store.getters.currencyCode }} {{ $numeral(minSettingDeposit).format("0,0.00") }})
    .d-flex.gap-2
      input.form-control(:class="{'disable-display': promoId !== ''}" type="text" :placeholder="'eg. ' + minSettingDeposit" v-model.trim="$v.gsPayDeposit.$model" @keypress="$helpers.onlyNumber"  :disabled="promoId !== ''" @input="handleInputChange")
    ValidateResult(:value="$v.gsPayDeposit" :name="$t('ui.amount')")
    .quickamo-wrap.mt-2
      a.quickamo(href="javascript:void(0)" @click="fillAmount(30, 1)" :class="{'active': quickamo==1}") RM 30
      a.quickamo(href="javascript:void(0)" @click="fillAmount(50, 2)" :class="{'active': quickamo==2}") RM 50
      a.quickamo(href="javascript:void(0)" @click="fillAmount(100, 3)" :class="{'active': quickamo==3}") RM 100
      a.quickamo(href="javascript:void(0)" @click="fillAmount(200, 4)" :class="{'active': quickamo==4}") RM 200
      a.quickamo(href="javascript:void(0)" @click="fillAmount(300, 5)" :class="{'active': quickamo==5}") RM 300
      a.quickamo(href="javascript:void(0)" @click="fillAmount(400, 6)" :class="{'active': quickamo==6}") RM 400
  .mb-3
    label.col-form-label {{$t('ui.select_bonus')}}:
    #accordion
      .tnc-card.bonus-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#bonusselect' aria-expanded='false' aria-controls='tnc1') {{$t('ui.select_bonus')}}
        #bonusselect.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .bonusselbox
            .nfwrap.epw-nfwrap
              //- .nftabs
                a.epw-nftabs.active(href='#' dd='slot') Slot
                a.epw-nftabs(href='#' dd='live') Live
                a.epw-nftabs(href='#' dd='welcome') Welcome Bonus
                a.epw-nftabs(href='#' dd='referral') Referral Bonus
              .nfcons
                template(v-for="(promo,index) in promotionList")
                  .nflist.epw-nflist.pointer(v-if="promo.promotion_id != null && promo.status ===  1" :class="{'active': promoId === promo.promotion_id}" @click="selectPromo(promo.promotion_id, promo.package_amount)")
                    input.radio.pointer(type='radio' v-model="promoId" :value="promo.promotion_id")
                    .ccon
                      .iimg
                        img(v-if="promo.bonus_rate === 10 || promo.bonus_rate === 12 || promo.bonus_rate === 15 || promo.bonus_rate === 20 || promo.bonus_rate === 25" :src="'/images/depo/promo/'+promo.bonus_rate+'.jpg'")
                        img(v-else :src="'assets/img/form-promo/'+(index+1)+'.png'")
                      .intro
                        .desc
                          | {{promo.promotion_name}}
                        .info
                          small {{$t('ui.deposit')}}
                          span RM{{promo.package_amount}}
                          a.iicon(href='javascript:void(0)')
                            i.fa-solid.fa-info
                  
                .nflist.epw-nflist.pointer(@click="selectPromo('', gsPayDeposit)")
                  input.radio.pointer(type='radio' v-model="promoId" value="")
                  .ccon
                    .iimg
                      img(src='/images/depo/promo/no-promo.jpg')
                    .intro
                      .desc
                        | {{$tc('ui.promo_none')}} 
  .mb-3.text-center
    router-link.deposit-btn(v-if="isDirtyValid()" :to="'/gspay?amount=' + gsPayDeposit + '&bank=GSPAY&promo=' + promoId" target="_blank" @click.native="gspaySubmit") {{ $t('ui.deposit') }}
    button.login-btn(v-else @click.stop="$v.$touch();") {{ $t('ui.deposit') }}
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags"
import ValidateResult from "@/library/ValidateResult"
import {required, minLength, maxLength, sameAs, not, minValue, alphaNum} from "vuelidate/lib/validators"

export default {
  components: {
    ValidateResult
  },
  props: {
    minSettingDeposit: {
      type: Number,
      default: 0.0
    },
    promotionList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      gsPayDeposit: "",
      // tempDeposit: "",
      // conditionChecked: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      // getFreeSpin:false,
      // freeSpinAmount: 0,
      // freeSpinAmount: 0,
      // premiumSpin: false
      // euroTicket: false,
      // ticketAmount: 0,
      promoId: "",
      quickamo: 0
    }
  },
  validations() {
    return {
      gsPayDeposit: {
        required,
        minValue: minValue(this.minSettingDeposit)
      },
      // conditionChecked: {
      //   required(val) {
      //     return val;
      //   }
      // }
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  watch:{
    gsPayDeposit(newValue, oldValue){
      if(newValue){
        this.$v.$touch()
      }
    }
  },
  destroyed(){
  },
  mounted() {
  },
  methods: {
    handleInputChange(){
      this.quickamo = 0
    },
    checkFreeSpins(amount){
      var formatNumber = Number(amount);
      if(formatNumber < 50){
        this.getFreeSpin = false;
        // this.freeSpinAmount = 0;
        // this.premiumSpin = false;
        // this.euroTicket = false;
        this.ticketAmount = 0;      
      }else{
        this.getFreeSpin = true;
        // this.euroTicket = true;
        switch(true){
          case (formatNumber >=50 && formatNumber < 100):
            // this.freeSpinAmount = 2
            // this.premiumSpin = false;
            this.ticketAmount = 1;           
          break;
          case (formatNumber >=100 && formatNumber < 200):            
            // this.freeSpinAmount = 10
            // this.premiumSpin = false;
            this.ticketAmount = 3;
          break;
          case (formatNumber >= 200 && formatNumber < 500):
            // this.freeSpinAmount = 5
            // this.premiumSpin = true;
            this.ticketAmount =7;
          break;
          case (formatNumber >= 500 && formatNumber < 1000):
            // this.freeSpinAmount = 10
            // this.premiumSpin = true;
            this.ticketAmount = 10;
          break;
          case (formatNumber >= 1000):
            // this.freeSpinAmount = 50
            // this.premiumSpin = true;
            this.ticketAmount = 13;
          break;
          default:
            // this.freeSpinAmount = 0
            // this.premiumSpin = false;
            this.ticketAmount = 0;
        }
      }
    },
    fillAmount(amount, target){
      this.quickamo = target
      this.gsPayDeposit = amount;
      // this.checkFreeSpins(amount);
      this.clearPromo();
      this.$v.$touch()
    },
    selectPromo(id, amount){
      this.quickamo = 0
      this.promoId = id
      this.gsPayDeposit = amount;
      this.$v.$touch()
    },
    clearPromo(){
      this.promoId = ""
      // this.$emit('clearPromo');
    },
    isDirtyValid() {
      // this.$v.$touch()
      return this.$v.$dirty && !this.$v.$invalid
    },
    reset() {
      // this.tempDeposit = this.gsPayDeposit
      this.gsPayDeposit = ""
      this.feedback.success = true
      this.feedback.status = ""
      // this.conditionChecked = false
      this.getFreeSpin = false
      this.$v.$reset()
    },
    gspaySubmit() {
      this.$router.push({
        name:"statement",
        params:{
          "checkTrans": true
        }
      }).catch(error =>{})
    }
  }
}
</script>